import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\HomeController::welcome
* @see app/Http/Controllers/HomeController.php:16
* @route '/{edition}'
*/
export const welcome = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: welcome.url(args, options),
    method: 'get',
})

welcome.definition = {
    methods: ["get","head"],
    url: '/{edition}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::welcome
* @see app/Http/Controllers/HomeController.php:16
* @route '/{edition}'
*/
welcome.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return welcome.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::welcome
* @see app/Http/Controllers/HomeController.php:16
* @route '/{edition}'
*/
welcome.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: welcome.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::welcome
* @see app/Http/Controllers/HomeController.php:16
* @route '/{edition}'
*/
welcome.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: welcome.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HomeController::welcome
* @see app/Http/Controllers/HomeController.php:16
* @route '/{edition}'
*/
const welcomeForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: welcome.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::welcome
* @see app/Http/Controllers/HomeController.php:16
* @route '/{edition}'
*/
welcomeForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: welcome.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::welcome
* @see app/Http/Controllers/HomeController.php:16
* @route '/{edition}'
*/
welcomeForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: welcome.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

welcome.form = welcomeForm

/**
* @see \App\Http\Controllers\HomeController::awaiting
* @see app/Http/Controllers/HomeController.php:42
* @route '/{edition}/awaiting'
*/
export const awaiting = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: awaiting.url(args, options),
    method: 'get',
})

awaiting.definition = {
    methods: ["get","head"],
    url: '/{edition}/awaiting',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::awaiting
* @see app/Http/Controllers/HomeController.php:42
* @route '/{edition}/awaiting'
*/
awaiting.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return awaiting.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::awaiting
* @see app/Http/Controllers/HomeController.php:42
* @route '/{edition}/awaiting'
*/
awaiting.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: awaiting.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::awaiting
* @see app/Http/Controllers/HomeController.php:42
* @route '/{edition}/awaiting'
*/
awaiting.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: awaiting.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HomeController::awaiting
* @see app/Http/Controllers/HomeController.php:42
* @route '/{edition}/awaiting'
*/
const awaitingForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: awaiting.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::awaiting
* @see app/Http/Controllers/HomeController.php:42
* @route '/{edition}/awaiting'
*/
awaitingForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: awaiting.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::awaiting
* @see app/Http/Controllers/HomeController.php:42
* @route '/{edition}/awaiting'
*/
awaitingForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: awaiting.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

awaiting.form = awaitingForm

/**
* @see \App\Http\Controllers\HomeController::waitlisted
* @see app/Http/Controllers/HomeController.php:56
* @route '/{edition}/waitlisted'
*/
export const waitlisted = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: waitlisted.url(args, options),
    method: 'get',
})

waitlisted.definition = {
    methods: ["get","head"],
    url: '/{edition}/waitlisted',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::waitlisted
* @see app/Http/Controllers/HomeController.php:56
* @route '/{edition}/waitlisted'
*/
waitlisted.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return waitlisted.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::waitlisted
* @see app/Http/Controllers/HomeController.php:56
* @route '/{edition}/waitlisted'
*/
waitlisted.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: waitlisted.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::waitlisted
* @see app/Http/Controllers/HomeController.php:56
* @route '/{edition}/waitlisted'
*/
waitlisted.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: waitlisted.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HomeController::waitlisted
* @see app/Http/Controllers/HomeController.php:56
* @route '/{edition}/waitlisted'
*/
const waitlistedForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: waitlisted.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::waitlisted
* @see app/Http/Controllers/HomeController.php:56
* @route '/{edition}/waitlisted'
*/
waitlistedForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: waitlisted.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::waitlisted
* @see app/Http/Controllers/HomeController.php:56
* @route '/{edition}/waitlisted'
*/
waitlistedForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: waitlisted.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

waitlisted.form = waitlistedForm

/**
* @see \App\Http\Controllers\HomeController::notRegistered
* @see app/Http/Controllers/HomeController.php:96
* @route '/{edition}/not-registered'
*/
export const notRegistered = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: notRegistered.url(args, options),
    method: 'get',
})

notRegistered.definition = {
    methods: ["get","head"],
    url: '/{edition}/not-registered',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::notRegistered
* @see app/Http/Controllers/HomeController.php:96
* @route '/{edition}/not-registered'
*/
notRegistered.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return notRegistered.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::notRegistered
* @see app/Http/Controllers/HomeController.php:96
* @route '/{edition}/not-registered'
*/
notRegistered.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: notRegistered.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::notRegistered
* @see app/Http/Controllers/HomeController.php:96
* @route '/{edition}/not-registered'
*/
notRegistered.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: notRegistered.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HomeController::notRegistered
* @see app/Http/Controllers/HomeController.php:96
* @route '/{edition}/not-registered'
*/
const notRegisteredForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: notRegistered.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::notRegistered
* @see app/Http/Controllers/HomeController.php:96
* @route '/{edition}/not-registered'
*/
notRegisteredForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: notRegistered.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::notRegistered
* @see app/Http/Controllers/HomeController.php:96
* @route '/{edition}/not-registered'
*/
notRegisteredForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: notRegistered.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

notRegistered.form = notRegisteredForm

/**
* @see \App\Http\Controllers\HomeController::noPayment
* @see app/Http/Controllers/HomeController.php:70
* @route '/{edition}/no-payment'
*/
export const noPayment = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: noPayment.url(args, options),
    method: 'get',
})

noPayment.definition = {
    methods: ["get","head"],
    url: '/{edition}/no-payment',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::noPayment
* @see app/Http/Controllers/HomeController.php:70
* @route '/{edition}/no-payment'
*/
noPayment.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return noPayment.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::noPayment
* @see app/Http/Controllers/HomeController.php:70
* @route '/{edition}/no-payment'
*/
noPayment.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: noPayment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::noPayment
* @see app/Http/Controllers/HomeController.php:70
* @route '/{edition}/no-payment'
*/
noPayment.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: noPayment.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HomeController::noPayment
* @see app/Http/Controllers/HomeController.php:70
* @route '/{edition}/no-payment'
*/
const noPaymentForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: noPayment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::noPayment
* @see app/Http/Controllers/HomeController.php:70
* @route '/{edition}/no-payment'
*/
noPaymentForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: noPayment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::noPayment
* @see app/Http/Controllers/HomeController.php:70
* @route '/{edition}/no-payment'
*/
noPaymentForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: noPayment.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

noPayment.form = noPaymentForm

/**
* @see \App\Http\Controllers\HomeController::info
* @see app/Http/Controllers/HomeController.php:86
* @route '/{edition}/info'
*/
export const info = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: info.url(args, options),
    method: 'get',
})

info.definition = {
    methods: ["get","head"],
    url: '/{edition}/info',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::info
* @see app/Http/Controllers/HomeController.php:86
* @route '/{edition}/info'
*/
info.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return info.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::info
* @see app/Http/Controllers/HomeController.php:86
* @route '/{edition}/info'
*/
info.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: info.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::info
* @see app/Http/Controllers/HomeController.php:86
* @route '/{edition}/info'
*/
info.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: info.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HomeController::info
* @see app/Http/Controllers/HomeController.php:86
* @route '/{edition}/info'
*/
const infoForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: info.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::info
* @see app/Http/Controllers/HomeController.php:86
* @route '/{edition}/info'
*/
infoForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: info.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::info
* @see app/Http/Controllers/HomeController.php:86
* @route '/{edition}/info'
*/
infoForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: info.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

info.form = infoForm

const HomeController = { welcome, awaiting, waitlisted, notRegistered, noPayment, info }

export default HomeController